import { render, staticRenderFns } from "./goodsConnectBox.vue?vue&type=template&id=63283cdf&scoped=true"
import script from "./goodsConnectBox.vue?vue&type=script&lang=js"
export * from "./goodsConnectBox.vue?vue&type=script&lang=js"
import style0 from "./goodsConnectBox.vue?vue&type=style&index=0&id=63283cdf&prod&scoped=true&lang=css"
import style1 from "./goodsConnectBox.vue?vue&type=style&index=1&id=63283cdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63283cdf",
  null
  
)

export default component.exports